/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Grid2} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    Category,
    Flag,
    FlagOutlined,
    Inventory2Outlined,
    MoneyOffCsred,
    PointOfSaleOutlined,
    TurnedInNotOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOPRODUCTOS} from "../../Constantes";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";

const Formulario_Producto = ({...props}) => {
    const [categorias, setCategorias] = useState([])
    const [oferta, setOferta] = useState('')


    useEffect(() => {


        obtenerCol('categorias').then((dox) => {
            if (dox.res) {
                setCategorias(dox.data)
            }
        })

    }, [])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={12} alto={9}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOPRODUCTOS.map((it) => it.nombre)}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}} sx={{mt: 0.5}}>

                    <IngresoSelectFuncion Icono={FlagOutlined} nombre={'Oferta'} dato={'oferta'} {...props}
                                          opciones={['Si', 'No']} setDato={setOferta}
                    />

                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Inventory2Outlined} nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={TurnedInNotOutlined} nombre={'Marca del producto'}
                                  dato={'marca'} {...props}

                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoSelect Icono={Category} nombre={'Categoria'}
                                   dato={'categoria'} {...props} opciones={categorias.map((it) => it.nombre)}
                                   requerido={'La Categoria es requerida'}

                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Presentacion'}
                                  dato={'presentacion'} {...props}
                    />
                </Grid2>

                {oferta === 'Si' &&

                    <>
                        <Grid container size={6} sx={{justifyContent: 'flex-start'}}>

                        </Grid>


                        <Grid2 container size={6}>
                            <IngresoDinero Icono={MoneyOffCsred} nombre={'Valor Antes'}
                                           dato={'valorAntes'} {...props}
                            />
                        </Grid2>

                    </>

                }

                <Grid2 container size={6}>
                    <IngresoDinero Icono={PointOfSaleOutlined} nombre={'Valor'}
                                   dato={'valor'} {...props}
                    />
                </Grid2>

                <Grid2 container size={12}>
                    <IngresoTexto lineas={3} nombre={'Descripcion adicional (opcional)'}
                                  dato={'descripcion'} {...props}
                    />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Producto